export default __webpack_public_path__ + "media/news.7b62d674.jpg";